import {
  Component,
  Directive,
  OnChanges,
  SimpleChanges,
  computed,
  input,
  output,
  signal,
} from '@angular/core';

@Directive({
  selector: '[cuiExpandableItemTriggerFor]',
  standalone: true,
  exportAs: 'cuiExpandableItemTrigger',
  host: {
    '(click)': 'toggle($event)',
    '[attr.aria-controls]': 'cuiExpandableItemTriggerFor().panelId()',
    '[attr.aria-disabled]': 'isDisabled() ? "true" : null',
    '[attr.aria-expanded]': 'isExpanded()',
  },
})
export class ExpandableItemTriggerDirective {
  readonly cuiExpandableItemTriggerFor = input.required<ExpandableItemComponent>();
  readonly cuiExpandableItemToggle = input(true);
  readonly isExpanded = computed(() => this.cuiExpandableItemTriggerFor().isExpanded());
  readonly isDisabled = computed(() => this.cuiExpandableItemTriggerFor().disabled());

  toggle(event: Event): void {
    if (this.isDisabled()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    if (this.cuiExpandableItemToggle()) {
      this.cuiExpandableItemTriggerFor().toggle();
    }
  }
}

@Component({
  selector: 'cui-expandable-item',
  standalone: true,
  host: {
    class: 'cui-expandable-item-host',
  },
  templateUrl: './expandable-item.component.html',
  styleUrl: './expandable-item.component.css',
})
export class ExpandableItemComponent implements OnChanges {
  disabled = input(false);
  expanded = input(false);
  itemId = input.required<string>();

  expandedChange = output<boolean>();
  readonly isExpanded = signal(false);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['expanded']) {
      this.isExpanded.set(this.expanded());
    }
  }

  panelId(): string {
    return `cui-expandable-item-panel-${this.itemId()}`;
  }

  toggle(): void {
    const expanded = !this.isExpanded();
    this.isExpanded.set(expanded);
    this.expandedChange.emit(expanded);
  }
}
